import Close from '@ixigo/icons/Close';
import Bottomsheet, { type BottomsheetProps } from '@ixigo/iui/Bottomsheet';
import IconButton from '@ixigo/iui/IconButton';
import cn from '../../utils/cn';
import { AnimateSize } from '../animate-size';

interface ExtendedBottomsheetProps extends BottomsheetProps {
	showCloseButton?: boolean;
}

export const BottomsheetExtended = ({
	children,
	onClose,
	open = false,
	showCloseButton = false,
	classes,
	...restBottomsheetProps
}: ExtendedBottomsheetProps) => {
	const closeButtonClass = cn(
		'absolute left-1/2 -translate-x-1/2 transition-all duration-300 ease-in-out shadow-lg -top-[60px]',
		open ? 'scale-100 opacity-100' : 'scale-0 opacity-0',
	);

	return (
		<Bottomsheet
			open={open}
			onClose={onClose}
			slotProps={{
				backdrop: {
					className: 'bg-opacity-70 backdrop-blur-xs',
				},
			}}
			classes={{
				...classes,
				container: cn(
					'w-full bottom-sheet h-auto',
					classes?.container || '',
					showCloseButton && 'overflow-y-visible',
				),
			}}
			{...restBottomsheetProps}
		>
			<AnimateSize>
				{showCloseButton && (
					<IconButton
						onClick={onClose}
						className={closeButtonClass}
						radius="full"
						color="neutral"
						variant="solid"
					>
						<Close />
					</IconButton>
				)}
				{children}
			</AnimateSize>
		</Bottomsheet>
	);
};
